export default "__VITE_ASSET__bojt4wxo__"